/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import { Box } from '@material-ui/core';
import { ImageCropResult } from 'models';
import clsx from 'clsx';
import { ImageAspectRatio, UploadedImage } from 'models/forms';
import ImageCropper from '../ImageCropper';
import EmptyImage from './EmprtyImage';
import Image from './FilledImage';
import useStyles from './style';

interface Props {
  imageURL?: string;
  aspectRatio: ImageAspectRatio;
  onChange: (image: UploadedImage) => void;
}

const ImageUploader: React.FC<Props> = (props) => {
  const { imageURL, aspectRatio, onChange } = props;
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(false);
  const [image, setImage] = useState(imageURL || (null as null | string));
  const [uploadedImage, setUploadedImage] = useState('');

  const handleCapture = ({ target }: any): void => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(target.files[0]);
    fileReader.onload = (e): void => {
      if (e.target && e.target.result) {
        setUploadedImage(e.target.result.toString());
        setIsOpen(true);
      }
    };
  };

  const handleCropAccept = (cropResult: ImageCropResult): void => {
    setIsOpen(false);
    setImage(cropResult.url);
    onChange({ url: cropResult.url, file: cropResult.file });
  };

  const handleCropCancel = (): void => {
    setIsOpen(false);
  };

  return (
    <>
      <Box
        className={clsx({
          [classes.containerHorizontal]:
            aspectRatio === ImageAspectRatio.AR_9_16,
          [classes.containerVertical]: aspectRatio === ImageAspectRatio.AR_2_3,
        })}
      >
        {!image && (
          <EmptyImage onChange={handleCapture} aspectRatio={aspectRatio} />
        )}
        {image && (
          <Image
            src={image}
            onChange={handleCapture}
            aspectRatio={aspectRatio}
          />
        )}
      </Box>
      <ImageCropper
        isOpen={isOpen}
        src={uploadedImage}
        aspectRatio={aspectRatio}
        handleAccept={handleCropAccept}
        handleCancel={handleCropCancel}
      />
    </>
  );
};

export default ImageUploader;
